"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SpacesDOMWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SpacesDOMWrapper, _Component);

  var _super = _createSuper(SpacesDOMWrapper);

  function SpacesDOMWrapper() {
    var _this;

    (0, _classCallCheck2.default)(this, SpacesDOMWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      error: undefined
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "appInstance", void 0);
    return _this;
  }

  (0, _createClass2.default)(SpacesDOMWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          targetUrl = _this$props.targetUrl,
          otp = _this$props.otp,
          config = _this$props.config;
      var appConfig = {
        el: this.ref.current,
        targetUrl: targetUrl,
        otp: otp,
        brandConfig: config
      };

      try {
        // @ts-expect-error - this is a global variable injected by the remote entry script
        this.appInstance = window.SpacesDOM.createApp(appConfig);

        if (!this.appInstance) {
          throw new Error('Failed to create Spaces app instance');
        }

        this.appInstance.init();
      } catch (error) {
        this.setState({
          error: error
        });
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      if (!this.appInstance) {
        // Spaces app instance not yet initialized
        return;
      }

      if (this.props.config === nextProps.config) {
        // Configuration has not been changed, so we don't need to update it
        return;
      }

      try {
        this.appInstance.updateBrandConfig(nextProps.config);
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return (0, _preact.h)("div", null, this.state.error.message);
      }

      return (0, _preact.h)("div", {
        ref: this.ref
      });
    }
  }]);
  return SpacesDOMWrapper;
}(_preact.Component);

var _default = SpacesDOMWrapper;
exports.default = _default;